<template>
  <div class="d-flex flex-column justify-center align-center py-2">
    <EmptyState
      class="py-14"
      :icon="'mdi-beehive-outline'"
      :iconSize="36"
      :title="$t('team.info.members.empty_state')"
      :buttonText="
        canAddMembers ? $t('team.info.members.empty_state_cta') : null
      "
      @click="isTeamFormVisible = true"
    />

    <TeamFormDialog
      v-if="isTeamFormVisible"
      :show="isTeamFormVisible"
      :team="team"
      :organizationId="organizationId"
      :siteId="siteId"
      @close="isTeamFormVisible = false"
      @updated="handleTeamUpdated"
      @created="handleTeamCreated"
    />
  </div>
</template>

<script>
import TeamFormDialog from '@/components/TeamFormDialog.vue'

import mixin from '@/mixins/mixin.vue'

import { mapGetters } from 'vuex'
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'TeamMembersEmptyState',

  mixins: [mixin],

  components: {
    TeamFormDialog,
    EmptyState,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },

    canAddMembers: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isTeamFormVisible: false,
    }
  },

  computed: {
    ...mapGetters(['organizationId', 'siteId']),
  },

  methods: {
    handleTeamUpdated(team) {
      this.isTeamFormVisible = false
      this.$emit('updated', team)
    },

    handleTeamCreated(team) {
      this.navigateTo({
        name: 'teamDetails',
        params: { teamId: team.id },
      })
    },
  },
}
</script>
